import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=161a94ca&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161a94ca')) {
      api.createRecord('161a94ca', component.options)
    } else {
      api.reload('161a94ca', component.options)
    }
    module.hot.accept("./LayoutVertical.vue?vue&type=template&id=161a94ca&", function () {
      api.rerender('161a94ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/LayoutVertical.vue"
export default component.exports